var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Linkedin"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.860352,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#1C202D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 19.5775C16 18.5001 16.3829 17.6112 17.1486 16.9109C17.9144 16.2105 18.9099 15.8604 20.1351 15.8604C21.3385 15.8604 22.3121 16.2051 23.056 16.8947C23.8217 17.6058 24.2046 18.5324 24.2046 19.6745C24.2046 20.7088 23.8327 21.5708 23.0888 22.2603C22.323 22.9715 21.3166 23.327 20.0695 23.327H20.0367C18.8333 23.327 17.8597 22.9715 17.1158 22.2603C16.3719 21.5492 16 20.6549 16 19.5775ZM16.4266 47.8603V26.2684H23.7124V47.8603H16.4266ZM27.749 47.8603H35.0347V35.8038C35.0347 35.0495 35.1223 34.4677 35.2973 34.0583C35.6036 33.3256 36.0685 32.7061 36.6921 32.1997C37.3156 31.6933 38.0978 31.4401 39.0386 31.4401C41.4891 31.4401 42.7143 33.067 42.7143 36.3209V47.8603H50V35.4805C50 32.2913 49.2342 29.8724 47.7027 28.224C46.1712 26.5755 44.1474 25.7512 41.6313 25.7512C38.8089 25.7512 36.61 26.9472 35.0347 29.3391V29.4038H35.0019L35.0347 29.3391V26.2684H27.749C27.7928 26.958 27.8147 29.1021 27.8147 32.7007C27.8147 36.2994 27.7928 41.3525 27.749 47.8603Z",
    fill: "#6C84F8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.5fbe5642b4395b71eff69affb4e8cd8b.svg";
export { ForwardRef as ReactComponent };